import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

// import VMIDDecoder from './VMIDDecoder';

import DevicesScreen from '../../../../views/VMlistComponens/Devices/DevicesScreen';
import DeviceDetailer from '../../../../views/VMlistComponens/DeviceDetailer/DeviceDetailer';


const DeviceManager = () => {
	return (
		<Routes>
			<Route
				path=":vmID/detailer"
				element={<DeviceDetailer />}
			/>
			<Route path="" element={<DevicesScreen />} />
		</Routes>
	);
};

//<Container fluid>
export default DeviceManager;
